import { render } from "./ProfileLink.vue?vue&type=template&id=c158a088"
import script from "./ProfileLink.vue?vue&type=script&lang=js"
export * from "./ProfileLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__